const ITEMS = [
  "Hotel Anil Palace · Hemmadi",
  "Kollur Mookambika Pilgrimage",
  "Maravante Beach Sunsets",
  "Maranakatte Heritage Shrine",
  "AC Deluxe Rooms",
  "24×7 Hot Water & Parking",
  "ಕೊಲ್ಲೂರು ಮೂಕಾಂಬಿಕೆ ದರ್ಶನ",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="marquee-mask overflow-hidden border-y border-gold/25 bg-maroon py-5"
    >
      <div className="flex w-max animate-marquee items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`whitespace-nowrap px-8 font-display text-lg italic tracking-wide text-amber-100/90 sm:text-xl ${
                /[\u0C80-\u0CFF]/.test(item) ? "font-kannada not-italic" : ""
              }`}
            >
              {item}
            </span>
            <span className="text-[10px] text-gold">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
